import { partnerLogos } from './content';
import { useI18n } from '@/hooks/useI18n';
import styles from './PartnerLogos.module.css';

export function PartnerLogos() {
  const { t } = useI18n();

  return (
    <section className={styles.section} id="aliados">
      <div className="ilu-container">
        <span className="ilu-eyebrow">{t.marketing.partners.eyebrow}</span>
        <h2 className={styles.title}>{t.marketing.partners.title}</h2>
        <div className={styles.grid}>
          {partnerLogos.map((src) => (
            /*
              Los archivos de logo no traen el nombre del aliado y no tenemos
              la lista oficial; un `alt` inventado sería peor que ninguno. Al
              ser decorativos (la sección ya se anuncia con su encabezado), van
              con alt vacío y aria-hidden.
            */
            <img key={src} src={src} alt="" aria-hidden="true" className={styles.logo} loading="lazy" />
          ))}
        </div>
      </div>
    </section>
  );
}
